'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _capitalize2 = require('lodash/capitalize');

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _advancedSearch = require('./advanced-search');

var _advancedSearch2 = _interopRequireDefault(_advancedSearch);

var _specialtySvgIcon = require('../../../specialty-svg-icon');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _showSearchInputRequiredMessage = require('../../../../src/client/utils/show-search-input-required-message');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BORDER_GREY = '#ddd';
var BG_GREY = '#f9f9f9';

var lastY = void 0;
var setLastY = function setLastY(event) {
  lastY = event.touches[0].clientY;
};

var stopScrollBleed = function stopScrollBleed(event) {
  // Check classnames. If one of these matches, the event began on something that should allow scrolling...
  if (event.target.className.trim().includes(_style2.default.refineCategoryOption.trim()) || event.target.parentElement.className.trim().includes(_style2.default.refineCategoryOption.trim()) || event.target.className.trim().includes(_style2.default.filterContainer.trim()) || event.target.parentElement.className.trim().includes(_style2.default.filterContainer.trim())) {

    var ul = event.target.parentElement.tagName === 'UL' ? event.target.parentElement : event.target.parentElement.parentElement;
    var currentY = event.touches[0].clientY;
    if (currentY > lastY && ul.parentElement.scrollTop === 0) {
      event.preventDefault();
      event.stopPropagation();
    } else if (currentY < lastY && Math.abs(ul.getBoundingClientRect().bottom - ul.parentElement.getBoundingClientRect().bottom) < 1) {
      event.preventDefault();
      event.stopPropagation();
    }
    lastY = currentY;
  }
  // If not, then the scroll event should be blocked completely.
  else {
      event.preventDefault();
      event.stopPropagation();
    }
};

var closeModal = function closeModal(closeFunction) {
  document.getElementsByTagName('html')[0].removeEventListener('touchmove', stopScrollBleed, { passive: false, capture: true });
  document.getElementsByTagName('html')[0].removeEventListener('touchstart', setLastY, { passive: false, capture: true });
  closeFunction();
};

var MobileSearchMenu = function (_React$Component) {
  (0, _inherits3.default)(MobileSearchMenu, _React$Component);

  function MobileSearchMenu(props) {
    (0, _classCallCheck3.default)(this, MobileSearchMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    _this.specialistMenuItem = null;
    _this.healthcheckMenuItem = null;
    _this.scanMenuItem = null;
    return _this;
  }

  MobileSearchMenu.prototype.componentDidMount = function componentDidMount() {
    this.props.menuItemClick('keyword');
    this.selectMenuItem(this.specialistMenuItem);
  };

  MobileSearchMenu.prototype.selectMenuItem = function selectMenuItem(selectedMenuItem) {
    var menuItems = [this.specialistMenuItem, this.healthcheckMenuItem, this.scanMenuItem];
    menuItems.forEach(function (menuItem) {
      menuItem.style.top = 0;
      menuItem.style.height = '15%';
    });

    selectedMenuItem.style.background = BORDER_GREY;
  };

  MobileSearchMenu.prototype.AppointmentTypeLabel = function AppointmentTypeLabel() {
    switch (this.props.selectedMenuItem) {
      case 'keyword':
        return 'All Specialties';
      case 'healthcheck':
        return 'All Treatments';
      case 'scan':
        return 'All Scans';
      default:
        return 'All Specialties';
    }
  };

  MobileSearchMenu.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var filterInput = void 0;

    var debouncedFilterChange = void 0;
    var refineCategoryOptions = void 0;
    if (props.refineCategory === 'keyword') {
      refineCategoryOptions = props.keywords;
      debouncedFilterChange = (0, _debounce3.default)(props.keywordFilterChange, 400);
    } else if (props.refineCategory === 'location') {
      refineCategoryOptions = props.locations;
      debouncedFilterChange = (0, _debounce3.default)(props.locationFilterChange, 400);
    } else if (props.refineCategory === 'insurer') {
      refineCategoryOptions = props.insurers;
      debouncedFilterChange = function debouncedFilterChange() {};
    }

    var subspecialtyList = props.selectedParentSpecialty ? props.selectedParentSpecialty.children : null;

    if (typeof document !== 'undefined' && props.open) {
      document.getElementsByTagName('html')[0].addEventListener('touchmove', stopScrollBleed, { passive: false, capture: true });
      document.getElementsByTagName('html')[0].addEventListener('touchstart', setLastY, { passive: false, capture: true });
    }

    var autocompleteSearchItems = props.keywords;
    var isSpecialtiesAvailable = autocompleteSearchItems.some(function (item) {
      return item.type === 'specialty' || item.keyword_type === 'specialty';
    });

    return _react2.default.createElement(
      'div',
      { id: '' + _style.MobileSearchMenuWrapper, className: '' + (props.open ? '' : _style.hidden) },
      _react2.default.createElement(
        'div',
        { id: '' + _style.MobileSearchMenuRoot },
        _react2.default.createElement(
          'div',
          { className: _style.closeTab + ' ' + (props.selectedMenuItem ? _style.back : ''),
            onClick: function onClick() {
              closeModal(props.closeTabClick);
            } },
          _react2.default.createElement('i', { className: props.selectedMenuItem ? 'ion-ios-arrow-left' : 'ion-ios-arrow-down' })
        ),
        _react2.default.createElement(
          'div',
          { className: '' + _style.appointmentTypeListContainer },
          _react2.default.createElement(
            'div',
            { className: _style.backButton + ' ' + (props.selectedMenuItem && props.refineCategory ? _style.backButtonVisible : ''),
              onClick: function onClick(event) {
                event.stopPropagation();
                event.preventDefault();
                if (subspecialtyList) {
                  props.clearSelectedParentSpecialty();
                  return;
                }
                if (props.refineCategory) {
                  if (props.refineCategory === 'keyword' && filterInput && filterInput.value && (!props.selectedKeyword || filterInput.value !== props.selectedKeyword.name)) {
                    debouncedFilterChange('');
                  }
                  props.clearSelectedRefineCategory();
                  return;
                }
                if (props.selectedMenuItem) {
                  props.clearSelectedMenuItem();
                  props.clearLocation();
                }
              } },
            _react2.default.createElement('i', { className: 'ion-ios-arrow-left' })
          ),
          _react2.default.createElement(
            'ul',
            { className: '' + _style.appointmentTypeList },
            _react2.default.createElement(
              'li',
              { ref: function ref(li) {
                  _this2.specialistMenuItem = li;
                },
                className: _style.appointmentTypeListItem + ' ' + (props.selectedMenuItem === 'keyword' ? _style.selectedMenuItem : ''),
                onClick: function onClick() {
                  props.menuItemClick('keyword');
                  _this2.selectMenuItem(_this2.specialistMenuItem);
                } },
              _react2.default.createElement('i', { className: 'ion-ios-pulse-strong' }),
              _react2.default.createElement(
                'span',
                null,
                'Appointment With Specialist'
              )
            ),
            _react2.default.createElement(
              'li',
              { ref: function ref(li) {
                  _this2.healthcheckMenuItem = li;
                },
                className: _style.appointmentTypeListItem + ' ' + (props.selectedMenuItem === 'healthcheck' ? _style.selectedMenuItem : ''),
                onClick: function onClick() {
                  props.menuItemClick('healthcheck');
                  _this2.selectMenuItem(_this2.healthcheckMenuItem);
                } },
              _react2.default.createElement('i', { className: 'ion-ios-heart-outline' }),
              _react2.default.createElement(
                'span',
                null,
                'Treatment'
              )
            ),
            _react2.default.createElement(
              'li',
              { ref: function ref(li) {
                  _this2.scanMenuItem = li;
                },
                className: _style.appointmentTypeListItem + ' ' + (props.selectedMenuItem === 'scan' ? _style.selectedMenuItem : ''),
                onClick: function onClick() {
                  props.menuItemClick('scan');
                  _this2.selectMenuItem(_this2.scanMenuItem);
                } },
              _react2.default.createElement('i', { className: 'ion-qr-scanner' }),
              _react2.default.createElement(
                'span',
                null,
                'Scan'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '' + _style.refineSearchOptionsContainer },
          _react2.default.createElement(
            'ul',
            { className: '' + _style.refineSearchOptions },
            props.selectedMenuItem === 'keyword' && _react2.default.createElement(
              'li',
              { className: _style.refineSearchOptionsItem + ' ' + _style.threeItems,
                onClick: function onClick() {
                  props.refineChangeClick('insurer');
                } },
              _react2.default.createElement('i', { className: 'ion-ios-paper-outline' }),
              _react2.default.createElement(
                'span',
                { className: '' + (props.selectedInsurer ? '' : _style.categoryPlaceholder) },
                props.selectedInsurer ? props.selectedInsurer.name : 'Hospital List'
              ),
              _react2.default.createElement(
                'button',
                { className: '' + _style.changeRefineSearchButton,
                  onClick: function onClick() {
                    props.refineChangeClick('insurer');
                  } },
                props.selectedInsurer ? 'Change' : 'Select'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: _style.refineSearchOptionsItem + ' ' + (props.selectedMenuItem === 'keyword' ? _style.threeItems : ''),
                onClick: function onClick() {
                  props.refineChangeClick('keyword');
                } },
              _react2.default.createElement('i', { className: 'ion-ios-pulse' }),
              _react2.default.createElement(
                'span',
                { className: '' + (props.selectedKeyword ? '' : _style.categoryPlaceholder) },
                props.selectedKeyword ? props.selectedKeyword.name.split(' ').map(function (word) {
                  return (0, _capitalize3.default)(word);
                }).join(' ') : this.AppointmentTypeLabel()
              ),
              _react2.default.createElement(
                'button',
                { className: '' + _style.changeRefineSearchButton,
                  onClick: function onClick() {
                    props.refineChangeClick('keyword');
                  } },
                props.selectedKeyword ? 'Change' : 'Select'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: _style.refineSearchOptionsItem + ' ' + (props.selectedMenuItem === 'keyword' ? _style.threeItems : ''),
                onClick: function onClick() {
                  props.refineChangeClick('location');
                } },
              _react2.default.createElement('i', { className: 'ion-ios-location-outline' }),
              _react2.default.createElement(
                'span',
                { className: '' + (props.selectedLocation || props.usingNearMe ? '' : _style.categoryPlaceholder) },
                props.usingNearMe && 'Near Me' || props.selectedLocation && props.selectedLocation.name || 'Location'
              ),
              _react2.default.createElement(
                'button',
                { className: '' + _style.changeRefineSearchButton,
                  onClick: function onClick() {
                    props.refineChangeClick('location');
                  } },
                props.selectedLocation ? 'Change' : 'Select'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _style.refineSearchKeywordListContainer + ' ' + (props.showRefineCategoryMenu ? _style.showRefineSearchKeywordList : '') + ' ' + (subspecialtyList ? _style.showSubspecialtyList : '') },
            (props.refineCategory === 'location' || props.refineCategory === 'keyword') && _react2.default.createElement(
              'div',
              { className: '' + _style.filterContainer },
              _react2.default.createElement('input', { ref: function ref(input) {
                  filterInput = input;
                },
                type: 'text',
                placeholder: props.refineCategory === 'location' && props.usingNearMe && props.findingLocation && 'Finding Location...' || props.refineCategory === 'location' && props.usingNearMe && 'Near Me' || 'Type to Search...',
                onChange: function onChange(event) {
                  debouncedFilterChange(event.target.value);
                },
                onFocus: function onFocus() {
                  if (props.refineCategory === 'location') {
                    props.clearLocationNearMe();
                  }
                },
                onKeyDown: function onKeyDown(event) {
                  if (event.key.toLowerCase() === 'enter') {
                    filterInput.blur();
                  }
                }
              }),
              props.refineCategory === 'location' && _react2.default.createElement(
                'div',
                { className: _style.nearMeIcon + ' ' + (props.findingLocation ? _style.pulse : ''),
                  onClick: function onClick() {
                    filterInput.value = '';
                    props.getLocationNearMe().then(function () {
                      props.locationNearMeFound();
                    });
                  } },
                _react2.default.createElement('i', { className: 'ion-pinpoint ' + (props.findingLocation ? _style.pulse : '') })
              )
            ),
            refineCategoryOptions && _react2.default.createElement(
              'ul',
              null,
              Array.isArray(refineCategoryOptions) && refineCategoryOptions.map(function (option, index) {
                var profileImage = option.profile_image;
                return _react2.default.createElement(
                  'li',
                  { key: 'refineOption' + index,
                    className: _style.refineCategoryOption + ' ' + (option.isSectionHeader ? _style.sectionHeader : ''),
                    onClick: function onClick() {
                      if (option.isSectionHeader) {
                        return;
                      }
                      if (filterInput) {
                        filterInput.value = '';
                      }
                      if (option.type && (option.type === 'specialist' || option.type === 'practice')) {
                        props.goToProfile(option);
                        closeModal(props.closeTabClick);
                        props.clearLocation();
                      } else {
                        props.selectRefineCategoryOption(option);
                      }
                    } },
                  props.refineCategory !== 'insurer' && option.icon_uri && _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, {
                    specialtyIconUri: option.icon_uri,
                    className: _style.specialtyIcon
                  }) || profileImage && _react2.default.createElement('img', {
                    src: profileImage,
                    className: _style.profileImage
                  }) || null,
                  _react2.default.createElement(
                    'span',
                    null,
                    option.name.replace(/\b[a-z]/g, function (firstLetter) {
                      return firstLetter.toUpperCase();
                    })
                  ),
                  option.children && option.children.length > 0 && _react2.default.createElement(
                    'div',
                    { className: '' + _style.expandSubspecialtyList,
                      onClick: function onClick(event) {
                        props.expandParentCategoryOption(option);
                        event.stopPropagation();
                      } },
                    _react2.default.createElement('i', { className: 'ion-ios-arrow-right' })
                  )
                );
              }) || _react2.default.createElement(
                'li',
                { className: _style.refineCategoryOption + ' ' + _style.sectionHeader },
                _react2.default.createElement(
                  'span',
                  null,
                  'No results found!'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _style.refineSearchKeywordListContainer + ' ' + _style.refineSearchKeywordSubListContainer + ' ' + (subspecialtyList ? _style.showSubspecialtyList : '') },
            subspecialtyList && _react2.default.createElement(
              'ul',
              null,
              subspecialtyList.map(function (child, subIndex) {
                return _react2.default.createElement(
                  'li',
                  { key: 'refineOptionChild' + subIndex,
                    className: '' + _style.refineCategoryOption,
                    onClick: function onClick() {
                      filterInput.value = '';
                      props.selectRefineCategoryOption(child);
                    } },
                  child.icon_uri ? _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, {
                    specialtyIconUri: child.icon_uri,
                    className: _style.specialtyIcon
                  }) : null,
                  _react2.default.createElement(
                    'span',
                    null,
                    child.name.replace(/\b[a-z]/g, function (firstLetter) {
                      return firstLetter.toUpperCase();
                    })
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          'button',
          {
            className: '' + _style.mobileSearchButton,
            onClick: function onClick() {
              if (!props.selectedInsurer) {
                props.refineChangeClick('insurer');
              } else if (filterInput && filterInput.value && (!props.selectedKeyword || filterInput.value !== props.selectedKeyword.name)) {
                if (props.refineCategory === 'keyword') {
                  (0, _showSearchInputRequiredMessage.showSearchInputRequiredMessage)(filterInput, isSpecialtiesAvailable);
                } else {
                  props.refineChangeClick('keyword');
                }
              } else {
                closeModal(props.closeTabClick);
                props.clearLocation();
                props.doSearch();
              }
            }
          },
          'Search'
        ),
        props.enableAdvancedSearch && _react2.default.createElement(
          'div',
          { className: _style2.default.advancedTab + ' ' + (props.showAdvancedOptions ? _style2.default.active : ''),
            onClick: function onClick(event) {
              event.stopPropagation();
              event.preventDefault();
              props.toggleAdvancedOptions();
            } },
          _react2.default.createElement(
            'span',
            null,
            props.showAdvancedOptions ? 'Search' : 'Filters',
            '...'
          )
        ),
        props.showAdvancedOptions && _react2.default.createElement(_advancedSearch2.default, props)
      ),
      props.open && _react2.default.createElement('div', { className: _style.overlay,
        ref: function ref(div) {
          if (div) {
            div.addEventListener('touchmove', stopScrollBleed, { passive: false });
          }
        },
        onClick: function onClick() {
          closeModal(props.closeTabClick);
          props.clearLocation();
        } })
    );
  };

  return MobileSearchMenu;
}(_react2.default.Component);

MobileSearchMenu.displayName = 'MobileSearchMenu';

MobileSearchMenu.defaultProps = {};

exports.default = MobileSearchMenu;


// WEBPACK FOOTER //
// ./components/mobile-search-menu/lib/components/mobile-search-menu.js